import React from 'react';
import { IonIcon } from '@ionic/react';
import { statsChartOutline } from 'ionicons/icons';
import type { Period, SalesBlock } from '../../api/types';
import { KpiPanels, YoYBadge } from '../../components';
import { PERIOD_LABELS, orderPair } from '../../utils/periods';
import { formatMoney, MONEY_UNIT, formatInt } from '../../utils/format';
import '../home/home.css';

interface Props {
  title: string;
  block: SalesBlock | null | undefined;
  unavailable?: boolean;
  loading?: boolean;
  period?: Period;
  /** Second period shown beside `period` (Today + WTD, WTD + MTD). */
  comparePeriod?: Period | null;
}

const SalesCard: React.FC<Props> = ({ title, block, unavailable, loading, period, comparePeriod }) => {
  const rows = block && period && comparePeriod
    ? orderPair(period, comparePeriod).map((p) =>
        p === period
          ? { label: PERIOD_LABELS[p], sales: block.sales, ly: block.ly_sales, yoy: block.yoy_pct }
          : { label: PERIOD_LABELS[p], sales: block.compare_sales, ly: block.compare_ly_sales, yoy: block.compare_yoy_pct })
    : null;
  return (
  <div className="su-card su-kpi">
    <div className="su-net-head">
      <div>
        <div className="su-kpi-title" style={{ gap: 8, justifyContent: 'flex-start' }}>
          <span>{title}</span>
          {!unavailable && block && <span className="su-chip">{formatInt(block.store_count)} Stores</span>}
        </div>
      </div>
      <IonIcon icon={statsChartOutline} className="su-net-icon" aria-hidden="true" />
    </div>
    {unavailable ? (
      <div className="su-muted" style={{ padding: '12px 0' }}>LFL data coming soon</div>
    ) : loading && !block ? (
      <div className="su-skeleton" style={{ height: 70 }} />
    ) : rows ? (
      <KpiPanels panels={rows.map((r) => ({ label: r.label, sales: r.sales, lySales: r.ly, yoyPct: r.yoy }))} />
    ) : (
      <>
        <div className="su-kpi-value su-num">
          {formatMoney(block?.sales)}
          <span className="su-kpi-unit">{MONEY_UNIT.key}</span>
        </div>
        <div className="su-kpi-row">
          <span className="su-num">vs LY {formatMoney(block?.ly_sales)} {MONEY_UNIT.key}</span>
          <YoYBadge value={block?.yoy_pct} variant="inline" />
        </div>
      </>
    )}
  </div>
  );
};

export default SalesCard;
